import { parseStringPromise } from 'xml2js'

export interface BlogPost {
  link: string
  image: string
  title: string
  description: string
  postDate: string
}

async function getBlogPosts(): Promise<BlogPost[]> {
  const rssUrl = 'https://blog.huma.finance/rss.xml'

  try {
    const response = await fetch(rssUrl)
    const xmlData = await response.text()
    const parsedData = await parseStringPromise(xmlData, {
      explicitArray: false,
    })

    const blogPosts: BlogPost[] = parsedData.rss.channel.item.map(
      (item: any) => {
        const content = item['content:encoded']
        const imgRegex = /<img[^>]+src="([^">]+)"/g
        const match = imgRegex.exec(content)
        const image = match ? match[1] : ''

        const formatDate = (dateString: string): string => {
          const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }
          const date = new Date(dateString)
          return date.toLocaleDateString(undefined, options)
        }

        return {
          link: item.link,
          image,
          title: item.title,
          description: item.description,
          postDate: formatDate(item.pubDate),
        }
      },
    )

    return blogPosts
  } catch (error) {
    console.error('Error fetching blog posts:', error)
    return []
  }
}

export const blogService = {
  getBlogPosts,
}
